import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { createItem } from "../../api/generics";
import {
  RemissionNote,
  formatRemissionNoteNumber,
} from "../../models/remission-note";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";

interface RemissionNoteCancellationRetryModalProps {
  show: boolean;
  remissionNote?: RemissionNote;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const RemissionNoteCancellationRetryModal: React.FC<
  RemissionNoteCancellationRetryModalProps
> = ({ show, remissionNote, onCancel, onSuccess }) => {
  const [submitting, setSubmitting] = useState(false);

  const message = remissionNote
    ? `Está seguro de que quiere reintentar la anulación de la nota de remisión nº ${formatRemissionNoteNumber(
        remissionNote,
      )}?`
    : "";

  const onRetryClick = async () => {
    if (remissionNote !== undefined) {
      setSubmitting(true);
      const status = await createItem(`/cancellations/retry/`, {
        taxPayerId: remissionNote.taxPayerId,
        cdcs: [remissionNote.cdc],
      });

      if (status.status !== SUCCESS) {
        const message = status.detail ?? "Ha ocurrido un error!!";
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-warning" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Reintentar Anulación</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onRetryClick} color="warning">
          {submitting && (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          )}
          {submitting ? "Reintentando..." : "Reintentar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default RemissionNoteCancellationRetryModal;
